export enum ValuationPropertyType {
  APARTMENT = 'APARTMENT',
  HOUSE = 'HOUSE',
  GARAGE = 'GARAGE',
  COMMERCIAL_UNIT = 'COMMERCIAL_UNIT',
  MULTI_FAMILY_HOUSE = 'MULTI_FAMILY_HOUSE',
  OTHER = 'OTHER',
}

export type ValuationAddressDto = {
  city: string
  street: string
  houseNumber: string
}

export type ValuationRequestDto = {
  type: ValuationPropertyType
  address: ValuationAddressDto
}

export type ValuationResponseDto = {
  maxValue: number
  minValue: number
  recommendedValue: number
}

export type ValuationApiResponseDto = {
  value: number
  valueMin: number
}
